<template>
    <div>
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins()}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':false}">
                <!-- 可可爱爱没有脑袋 -->
                <Header :behavior="behavior" :type="type" :info="info" :buy_info="buy_info" />
            </div>
             <!-- {/* 冷门分析tab切换 */} -->
            <div :class="{'ai-tab':true, 'none':false}">
                <div @click="switchModelTab(1)">
                    <span :class="modelActive == 1? 'active':''">{{type == 15 || type == 22?'历史推荐':'历史命中'}}<em></em></span>
                </div>
                <div  @click="switchModelTab(2)">
                    <span :class="modelActive == 2? 'active':''">今日推荐<em></em></span>
                </div>
            </div>
            <!-- {/* 冷门分析今日推荐总概、tab */} -->
            <div :class="{'cold-summary':true, 'clearfloat':true, 'none':(type!=18 && type!=17 && type!=15 && type!=21 &&type!=22) || (type==18&&modelActive==1) || (type==17&&modelActive==1) || (type==16&&modelActive==1) || (type==15&&modelActive==1) ||(type==21&&modelActive==1)||(type==22&&modelActive==1)|| (info.status==-1|| info.status==0 || info.status == 3)}">
                <div :class="{'summary-txt':true, 'none':type==21||type==22}">推荐总数:{{coldList && coldList.length}}场 {{modelupdatetime}}分钟前更新</div>
                <div :class="{'summary-txt':true, 'none':type!=21}">推荐总数:{{coldList && coldList.length}}场 每分钟更新</div>
                <div :class="{'summary-txt':true, 'none':type!=22}">推荐总数:{{coldList && coldList.length}}场 1分钟前更新</div>
                <!-- {/* 冷门 */} -->
                <div :class="{'summary-btn':true,'fl-r':true,'none':type != 18}">
                    <div :class="commandActive == 1? 'active':''" onClick={self.coldcommandTab.bind(self,1)}>按时间</div>
                    <div :class="commandActive == 2? 'active':''" onClick={self.coldcommandTab.bind(self,2)}>按指数</div>
                </div>
                <!-- {/* 大数据 */} -->
                <div :class="{'summary-btn':true,'fl-r':true,'none':type != 15}">
                    <div :class="commandActive == 1? 'active':''" onClick={self.bigcommandTab.bind(self,1)}>按时间</div>
                    <div :class="commandActive == 2? 'active':''" onClick={self.bigcommandTab.bind(self,2)}>按认可度</div>
                </div>
                <div :class="{'jc':true,'fl-r':true,'none':type!=21&&type!=22}">
                    <span class="jingcai">竞彩</span>
                    <input ref="jccheck" class='switch' type="checkbox"  />
                </div>
            </div>
            <!-- {/* 日历切换 */} -->
            <div :class="{'daily-calendar':true,'none':type==6 || type==19 || type == 20 || (type==18&&modelActive==2) || (type==17&&modelActive==2) || (type==15&&modelActive==2)||(type==21&&modelActive==2)||(type==22&&modelActive==2)}">
                <template v-if="getCookies('JH') && info.status != 0 && info.status != 3 && tomorrow_num  > 0">
                     <i class="matchs-line"></i><b>预告明日{{tomorrow_num}}场比赛</b>
                </template>
                <!-- {/* 冷门等模型 */} -->
                <div :class="{'matchs-num':true,'none':false || ((type==16||type==15||type==21||type==22)&&modelActive==2&&(info.status==0||info.status==-1||info.status==3))}"><span :class="{'none':!(type==16&&modelActive==2)}">今日</span>{{coldtime}}(共{{coldList && coldList.length}}场) <i :class="{'icon':true,'i_calendar':true,'none':type==16&&modelActive==2}" @click="showCalendar = true"></i></div>
            </div>
             <!-- {/* 冷门模型列表 */} -->
            <!-- {} -->
            <div :class="{'daily-list': true, 'bg1': coldList&&coldList.length != 0 && (modelActive==1 || (modelActive==2&& info.status != -1&& info.status != 0&& info.status != 3)), 'none': loading || (type!=18&&type!=17&&type!=16&&type!=15&&type!=21&&type!=22)}">
                <div class="daily-package daily-2 nobg">
                    <ul>
                        <li class="daily-package-item no1">
                            <template v-if="modelActive == 2 && (info.status==-1 ||info.status==0 || info.status == 3)">
                                <div class="daily-find">
                                    <i class="daily-no-find"></i>
                                    <p>您目前暂未订购该模型，仅可查看往日推荐内容，<span class="gonow" onClick={self.go_daily_buy.bind(self,type,false)}>赶快去订购吧！</span></p>
                                </div>
                            </template>
                            <template v-else-if="coldList">
                                <template v-if="coldList.length > 0">
                                    <template v-if="type == 16 && modelActive == 1">
                                        <div class="package-dec dec_full">
                                            <div class="full-tips">各玩法命中数</div>
                                            <span class="fulldimenpre">胜平负：<cite>{{fullpre_total.standard_count}}</cite>场</span><span class="fulldimenpre">亚指让球：<cite>{{fullpre_total.letgoal_count}}</cite>场</span><span class="fulldimenpre">大小球：<cite>{{fullpre_total.totalscore_count}}</cite>场</span>
                                        </div>
                                    </template>
                                    <template v-for="(item,index) in coldList">
                                        <template v-if="type == 15 || type == 16 || type == 21|| type==22">
                                            <template v-if="type == 21">
                                                <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                    <div class="package-team info">
                                                        <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                    </div>
                                                    <div class="match-team-result">
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.home_logo || 'https://s.jihaimall.com/h5/image/home_new.png'" /></div>
                                                            <div class="team-name">{{item.home_team}}</div>
                                                        </div>
                                                        <template v-if="item.match_state == -1">
                                                            <div class="match-score">
                                                                <div class="xbc">{{item.home_score}}:{{item.guest_score}}</div>
                                                                <div class="sbc">({{item.home_half_score}}:{{item.guest_half_score}})</div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="match-vs-odds">VS</div>
                                                        </template>
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.guest_logo || 'https://s.jihaimall.com/h5/image/guest_new.png'" /></div>
                                                            <div class="team-name">{{item.guest_team}}</div>
                                                        </div>
                                                        <div></div>
                                                        <template v-if="item.match_state == -1">
                                                            <div class="fulldimen-match-res">
                                                                <div :class="{'txt':true,'none':item.rec_vs_hit ==0}"><span class="textred">{{item.rec_vs_hit_odds}}</span>倍比分<span class="hit">命中</span></div>
                                                                <div :class="{'txt':true,'none':item.rec_score_hit ==0}">进球数<span class="hit">命中</span></div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <RenderChar :item="item" />
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else-if="type == 22">
                                                <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                    <div class="package-team info">
                                                        <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                    </div>
                                                    <div class="match-team-result">
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.home_logo || 'https://s.jihaimall.com/h5/image/home_new.png'" /></div>
                                                            <div class="team-name">{{item.home_team}}</div>
                                                        </div>
                                                        <template v-if="item.match_state == -1">
                                                            <div class="match-score">
                                                                <div class="xbc">{{item.home_score}}:{{item.guest_score}}</div>
                                                                <div class="sbc">({{item.home_half_score}}:{{item.guest_half_score}})</div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="match-vs-odds">VS</div>
                                                        </template>
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.guest_logo || 'https://s.jihaimall.com/h5/image/guest_new.png'" /></div>
                                                            <div class="team-name">{{item.guest_team}}</div>
                                                        </div>
                                                        <div></div>
                                                        <!-- <template v-if="item.match_state == -1"> -->
                                                            <div class="package-data fullpre">
                                                                <div class="package-charts svg_circle">
                                                                    <div class="donut__svg__path">
                                                                    <div :id="'supermustsend'+index" class='containter'></div>
                                                                    </div>
                                                                </div>
                                                                <div class="packagesaqa">总交易量</div>
                                                            </div>
                                                        <!-- </template> -->
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                    <div class="package-team info">
                                                        <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                    </div>
                                                    <div class="match-team-result">
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.home_logo || 'https://s.jihaimall.com/h5/image/home_new.png'" /></div>
                                                            <div class="team-name">{{item.home_team}}</div>
                                                        </div>
                                                        <template v-if="item.match_state == -1">
                                                            <div class="match-score">
                                                                <div class="xbc">{{item.home_score}}:{{item.guest_score}}</div>
                                                                <div class="sbc">({{item.home_half_score}}:{{item.guest_half_score}})</div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="match-vs-odds">VS</div>
                                                        </template>
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img :src="item.guest_logo || 'https://s.jihaimall.com/h5/image/guest_new.png'" /></div>
                                                            <div class="team-name">{{item.guest_team}}</div>
                                                        </div>
                                                        <div></div>
                                                        <template v-if="item.match_state == -1">
                                                            <template v-if="type == 15">
                                                                <RenderChar :item="item" />
                                                            </template>
                                                            <template v-else-if="type == 16">
                                                                <div class="fulldimen-match-res">
                                                                    <div :class="{'txt':true,'none':item.totalscore_hit == 0}">大小球<span class="hit">命中</span></div>
                                                                    <div :class="{'txt':true,'none':item.standard_hit == 0}">胜平负<span class="hit">命中</span></div>
                                                                    <div :class="{'txt':true,'none':item.letgoal_hit == 0}">亚指让球<span class="hit">命中</span></div>
                                                                </div>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <RenderChar :item="item" />
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else-if="type == 18">
                                            <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                <div class="package-team info">
                                                    <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                </div>
                                                <div class="package-team sub">
                                                    <template v-if="item.match_state == -1">
                                                        <strong>{{item.home_team}}<span class="coldscore">{{item.home_score ? item.home_score+':'  : ''}}{{item.guest_score || ''}}</span>{{item.guest_team}}</strong>
                                                    </template>
                                                    <template v-else>
                                                        <strong>{{item.home_team}}<span>VS</span>{{item.guest_team}}</strong>
                                                    </template>
                                                </div>
                                                <div :class="{'package-team': true, 'des': true}">
                                                    <p>{{item.msg}}</p>
                                                </div>
                                                <template v-if="item.match_state == -1">
                                                    <div class="package-data">
                                                        <span class="coldpack-item">
                                                            <cite>{{Math.round(item.hit_odds*100)}}</cite>%
                                                            <p>命中冷门高赔</p>
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <RenderChar :item="item" />
                                                </template>
                                            </div>
                                        </template>
                                        <template v-else-if="type == 17">
                                            <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                <div class="package-team info">
                                                    <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                                </div>
                                                <div class="match-team-result">
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img :src="item.home_logo || 'https://s.jihaimall.com/h5/image/home_new.png'"/></div>
                                                        <div class="team-name">{{item.home_team}}</div>
                                                    </div>
                                                    <template v-if="item.match_state == -1">
                                                        <div class="match-score">
                                                            <div class="xbc">{{item.home_score}}:{{item.guest_score}}</div>
                                                            <div class="sbc">({{item.home_half_score}}:{{item.guest_half_score}})</div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="match-vs-odds">VS</div>
                                                    </template>
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img :src="item.guest_logo || 'https://s.jihaimall.com/h5/image/guest_new.png'" /></div>
                                                        <div class="team-name">{{item.guest_team}}</div>
                                                    </div>
                                                    <template v-if="item.match_state == -1">
                                                        <div class="match-res">
                                                            <div class="res-logo">
                                                                <img v-if="item.ret == 'home'" src="https://s.jihaimall.com/h5/image/datamodel/homewin.png" />
                                                                <img v-if="item.ret == 'guest'" src="https://s.jihaimall.com/h5/image/datamodel/guestwin.png" />
                                                                <img v-if="item.ret == 'stand'" src="https://s.jihaimall.com/h5/image/datamodel/stand.png" />
                                                            </div>
                                                            <div class="txt">赛果命中</div>
                                                            <div class="match-go"></div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div className="match-times">
                                                            <div className="res-times">{{item.count}}</div>
                                                            <div className="times-txt">波动相似场次</div>
                                                            <div className="match-go"></div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="daily-find">
                                        <i class="daily-no-find"></i>
                                        <p>暂无数据!</p>
                                    </div>
                                </template>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <Calendar
                :show="showCalendar"
                :start_time="start_time"
                :end_time="end_time"
                :current_time="current_time"
                @callback="updateDailyDate"
            />
        </div>
    </div>
</template>

<script>
import Down from "../../components/programme/appdown.vue"
import Header from "../../components/modelTemporary/header.vue"
import { isWeiXin, urlQuery, setTitle, formatDate, getCookie } from "../../utils/base"
import { getDataTypeListApi, getColdHisApi, getForwardApi } from "../../api/modelTemporary"
import mutil from "../../utils/mutil"
import RenderChar from "../../components/datamodel/common/renderSvg.vue"
import Calendar from "../../components/datamodel/common/calendar.vue"
export default {
    name: "outOfThe",
    components: {
        Down,
        Header,
        RenderChar,
        Calendar
    },
    data () {
        return {
            showCalendar: false,
            loading: false,
            type: this.$route.query.type || 15,
            today: [],
            tomorrow_num: 0,
            current_time: "",
            daytxt: "",
            start_time: "",
            end_time: "",
            coldtime: "",
            buy_info: {},
            info: {},
            modelActive: 1,
            behavior: 0,
            fullpre_total: [],
            coldList: [],
            modelupdatetime: [],
            commandActive: 1
        }
    },
    created () {
        this.getDataTypeList()
    },
    methods: {
        // 切换日历
        updateDailyDate (year, month, day) {
            window.sessionStorage.setItem("savedate", "");
            this.showCalendar = false
            this.loading = true
            this.getDataTypeList(year, month, day);
        },
        getCookies (key) {
            return getCookie(key)
        },
        isWeixins () {
            return isWeiXin()
        },
        // 环形图
        svgCircle () {
            // svg
            const donutSvgPath = document.querySelectorAll(".donut__svg__path");
            const donutSvgR = document.querySelectorAll(".donut__svg__r");
            for (var m = 0; m < donutSvgPath.length; m++) {
                const svgPath = donutSvgPath[m];
                const svgR = donutSvgR[m];
                const $path = svgPath.getElementsByTagName("circle");
                for (var n = 0; n < $path.length; n++) {
                    const pathCircle = $path[n];
                    const r = (svgPath.offsetWidth * 1 - svgR.offsetWidth * 1) / 2;
                    const cx = svgPath.offsetWidth * 1 / 2;
                    const cy = svgPath.offsetWidth * 1 / 2;
                    pathCircle.setAttribute("r", r);
                    pathCircle.setAttribute("cx", cx);
                    pathCircle.setAttribute("cy", cy);
                    pathCircle.setAttribute("fill", "none");
                    pathCircle.setAttribute("stroke-width", svgR.offsetWidth * 1);
                    // eslint-disable-next-line eqeqeq
                    if (n == 1) {
                        const perimeter = 2 * Math.PI * r;
                        const rangeValue = pathCircle.getAttribute("data-percent") * 1;
                        const radio = perimeter - (rangeValue / 100) * perimeter
                        pathCircle.style.strokeDasharray = pathCircle.style.strokeDashoffset = perimeter;
                        pathCircle.style.transition = "stroke-dashoffset 600ms ease-in-out";
                        pathCircle.style.strokeDashoffset = radio;
                    }
                }
            }
        },
        // 数据模型分析tab切换
        switchModelTab (num) {
            var order = "";
            // eslint-disable-next-line eqeqeq
            if (this.commandActive == 1) {
                order = "";
            // eslint-disable-next-line eqeqeq
            } else if (this.commandActive == 2) {
                order = 1;
            }
            this.coldList = ""
            this.modelActive = num
            window.sessionStorage.setItem("savedate", "");
            this.dataModelList(this.modelActive, order, null, null, null, 'isdatamodel');
        },
        // 获取冷门列表
        async dataModelList (tab, params, year, month, day, isdatamodel, record) {
            const type = this.type;
            let time = "";
            setTitle(mutil.dailyMap[type + '']);
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            var savedate = window.sessionStorage.getItem("savedate") || "";
            if (record || savedate) {
                time = savedate;
            }
            var modeljsons = {};
            var modeljson1 = {
                day_time: time || ""
            }
            var urlApi = ''
            // eslint-disable-next-line no-unused-vars
            var DefoturlApi = ''
            // eslint-disable-next-line eqeqeq
            if (type == 18 || type == 17 || type == 16 || type == 15) {
                // eslint-disable-next-line eqeqeq
                if (type == 18) {
                    DefoturlApi = "/data/oa/zq/analy/score/his"
                    modeljsons = {
                        method: "data/oa/zq/analy/cold/schedule",
                        data_type: type,
                        order: params || "",
                        display_all: 1
                    };
                    modeljson1.display_all = 1;
                // eslint-disable-next-line eqeqeq
                } else if (type == 15) {
                    DefoturlApi = "/data/oa/zq/analy/score/his"
                    modeljsons = {
                        method: "data/oa/zq/analy/score/schedule",
                        data_type: type,
                        order: params || ""
                    };
                // eslint-disable-next-line eqeqeq
                } else if (type == 16) {
                    DefoturlApi = "/data/oa/zq/analy/full/his";
                    modeljsons = {
                        // eslint-disable-next-line eqeqeq
                        method: "data/oa/zq/analy/full/schedule",
                        data_type: type,
                        order: params || ""
                    };
                } else {
                    DefoturlApi = "/data/oa/zq/analy/dis/his";
                    modeljsons = {
                        // eslint-disable-next-line eqeqeq
                        method: "data/oa/zq/analy/dis/schedule",
                        data_type: type,
                        order: params || ""
                    };
                }
                // '/data/oa/zq/analy/cold/his'
                urlApi = 1
            // eslint-disable-next-line eqeqeq
            } else if (type == 21 || type == 22) {
                modeljsons = {
                    jczc: 1,
                    method: "schedule",
                    data_type: type
                };
                // '/data/forward'
                urlApi = 2
            }
            // eslint-disable-next-line eqeqeq
            if (type == 21 && tab == 1) {
                modeljson1 = {
                    day_time: time || "",
                    method: "his",
                    data_type: type
                    // day_time: '2021-09-07'
                }
            }
            // eslint-disable-next-line eqeqeq
            if (type == 22 && tab == 1) {
                modeljson1 = {
                    data_type: type,
                    method: 'his',
                    day_time: time || ""
                }
            }
            // 历史命中
            // eslint-disable-next-line eqeqeq
            if (tab == 1) {
                let data = null
                if (urlApi === 1) {
                    data = await getColdHisApi(modeljson1, DefoturlApi)
                } else {
                    data = await getForwardApi(modeljson1)
                }
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    var coldhis = "";
                    // eslint-disable-next-line eqeqeq
                    if (type == 16) {
                        coldhis = data.data.result || [];
                        this.fullpre_total = data.data
                    } else {
                        coldhis = data.data;
                        // eslint-disable-next-line eqeqeq
                        if (type == 21) {
                            coldhis = data.data.list
                        }
                        // eslint-disable-next-line eqeqeq
                        if (type == 22) {
                            coldhis = data.data
                        }
                    }
                    // eslint-disable-next-line eqeqeq
                    if (isdatamodel == "isdatamodel") {
                        var today = new Date();
                        var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                        var todayNow = now[0] + "-" + now[1] + "-" + now[2];
                        this.coldtime = todayNow
                        this.current_time = todayNow
                    }
                    this.coldList = coldhis
                    this.loading = false
                    // eslint-disable-next-line eqeqeq
                    if (type == 15 || type == 21) {
                        this.$nextTick(() => {
                            this.svgCircle();
                        })
                    }
                }
            } else {
                // 今日推荐
                this.$refs.jccheck.checked = false
                const data = await getForwardApi(modeljsons)
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    // eslint-disable-next-line eqeqeq
                    if (isdatamodel == "isdatamodel") {
                        // eslint-disable-next-line no-redeclare
                        var today = new Date();
                        // eslint-disable-next-line no-redeclare
                        var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                        // eslint-disable-next-line no-redeclare
                        var todayNow = now[0] + "-" + now[1] + "-" + now[2];
                        this.coldtime = todayNow
                        this.current_time = todayNow
                    }
                    var todaydata = "";
                    // eslint-disable-next-line eqeqeq
                    if (type == 16) {
                        todaydata = data.data;
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 21) {
                        todaydata = data.data.list
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 22) {
                        todaydata = data.data
                    } else {
                        todaydata = data.data.result;
                    }
                    var commandtime;
                    if (data.data) {
                        commandtime = data.data.minutes || "";
                    }
                    this.coldList = todaydata
                    this.modelupdatetime = commandtime
                    this.loading = false
                    // eslint-disable-next-line eqeqeq
                    if (type == 18 || type == 16 || type == 15 || type == 21) {
                        this.svgCircle();
                    }
                }
            }
        },
        // 数据列表页
        async getDataTypeList (year, month, day, tab, cold) {
            const jsons = {};
            const type = this.type;
            let time = urlQuery("time") || "";
            jsons.type = type;
            // eslint-disable-next-line eqeqeq
            if (type != 18) {
                jsons.tab = tab || "r";
            }
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            if (time) {
                jsons.time = time;
            }
            setTitle(mutil.dailyMap[type + '']);
            const data = await getDataTypeListApi(jsons)
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                // eslint-disable-next-line no-redeclare
                var daily = data.data;
                var startTime = "";
                var endTime = "";
                var coldcurTime = "";

                var today = new Date();
                var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                var todaynow = now[0] + "-" + now[1] + "-" + now[2];
                // 冷门
                startTime = todaynow;
                endTime = todaynow;
                coldcurTime = todaynow;
                this.today = daily.todayData
                this.tomorrow_num = daily.tomorrowDataNum

                this.current_time = coldcurTime || daily.curDate
                this.daytxt = daily.day

                this.start_time = startTime
                this.end_time = endTime
                this.coldtime = startTime

                this.buy_info = {
                    total: data.buy_info.total,
                    avatar: data.buy_info.avatar
                }
                this.info = data.info
                this.loading = false
                // eslint-disable-next-line eqeqeq
                if (type == 18 || type == 17 || type == 16 || type == 15 || type == 21 || type == 22) {
                    var savedate = window.sessionStorage.getItem("savedate") || "";
                    if (savedate) {
                        // eslint-disable-next-line no-sequences
                        this.modelActive = 1
                        this.coldtime = savedate
                        this.current_time = savedate
                        this.dataModelList(1, null, null, null, null, null, savedate);
                    // eslint-disable-next-line eqeqeq
                    } else if (this.info.status == 0 || this.info.status == -1 || this.info.status == 3) {
                        this.modelActive = 1
                        this.dataModelList(1);
                    } else {
                        this.modelActive = 2
                        this.dataModelList(2);
                    }
                }
            }
        }
    }
}
</script>

<style>
@import url("../../assets/css/_discovery.min.css");
</style>
